import { cloneDeep, isArray, mergeWith } from 'lodash'
import { StateCreator } from 'zustand'

import { ECognitoGroups, EFeatureCode } from '~/models/auth'

type TOrganizationDefinition = {
  paymentTier: ECognitoGroups
  referralCode: string
  trialDaysLeft: number
  featureCodes: EFeatureCode[]
}

type TOrganization = {
  organization: TOrganizationDefinition
}

export type TOrganizationState = TOrganization & {
  setOrganization(organization: Partial<TOrganizationDefinition>): void
}

export const initialOrganizationState: TOrganizationDefinition = {
  paymentTier: ECognitoGroups.customerFreePlan,
  referralCode: '',
  trialDaysLeft: 0,
  featureCodes: [],
}

const createOrganizationSlice: StateCreator<
  TOrganizationState,
  [['zustand/devtools', unknown]],
  []
> = (set) => ({
  organization: cloneDeep(initialOrganizationState),
  setOrganization: (organization) =>
    set(
      (state) => ({
        organization: mergeWith(
          cloneDeep(state.organization),
          organization,
          (objValue, srcValue) => {
            if (isArray(objValue)) {
              return srcValue
            }
            // eslint-disable-next-line consistent-return
            return undefined
          },
        ),
      }),
      undefined,
      {
        type: 'setOrganization',
        organization,
      },
    ),
})

export default createOrganizationSlice
